export default {
  title: 'Non riuscite a trovare quello che state cercando? Lo progettiamo noi per voi!',
  subTitle:
    "Se avete bisogno di un'illustrazione scientifica che non è ancora disponibile nella nostra galleria, potete richiederla e la disegneremo per voi. Seguite i passaggi indicati di seguito:",
  stepOne:
    "Andare all area di lavoro e fare clic su Richiedi un Pulsante 'Illustrazione', a in basso a sinistra di il vostro schermo.",
  stepTwo:
    'Compilare il modulo con i dati dettagli sulla illustrazione scientifica necessità. È inoltre possibile allegare riferimenti, come la mano disegni e altri immagini.',
  stepThree:
    'La richiesta deve contenere circa 7 giorni lavorativi per essere pronti. Riceverete na e-mail quando la scienza l illustrazione è disponibile.',
  text: "È inoltre possibile richiedere un'illustrazione cliccando sul pulsante qui sotto",
  textButton: "Richiedi ora un'illustrazione",
};
